import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import View from './adaptive-mobility-external.presenter';
import {
  API_COMPLETE_GET_AME_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_AME_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_AME_SHOW_DATA,
  API_INITIATE_SUBMIT_AME_SHOW_DATA,
} from '../../app-constants';
import { submitAMECalCulatorData, submitAMEShowData, submitAMECalculatorTrackingData } from './adaptive-mobility-external.actions';
// Reducer
export const adaptiveMobilityExternalReducer = (state = {
  loading: false,
  dataLoaded: false,
  formSubmitted: false,
  backendOptimizedPlansWithDevices: [],
  backendSolutionFound: false,
  calculationInProgress: false,
  startTime: 0,
  endTime: 0,
}, action) => {
  switch (action.type) {
    case API_COMPLETE_GET_AME_CUSTOMER_DATA: {
      return {
        ...state,
        dataLoaded: true,
      };
    }
    case API_COMPLETE_SUBMIT_AME_CUSTOMER_DATA:
      return { ...state, loading: false, formSubmitted: true };
    case API_COMPLETE_SUBMIT_AME_SHOW_DATA:
      return { ...state,
        backendOptimizedPlansWithDevices: action.data.backendOptimizedPlansWithDevices,
        backendSolutionFound: action.data.solutionFound,
        calculationInProgress: false,
      };
    case API_INITIATE_SUBMIT_AME_SHOW_DATA:
      return { ...state, backendOptimizedPlansWithDevices: [], backendSolutionFound: false, calculationInProgress: true };
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  authorableContent: state.authorableContentReducer.authorableContent,
  dataLoaded: state.adaptiveMobilityExternalReducer.dataLoaded,
  formSubmitted: state.adaptiveMobilityExternalReducer.formSubmitted,
  backendOptimizedPlansWithDevices: state.adaptiveMobilityExternalReducer.backendOptimizedPlansWithDevices,
  backendSolutionFound: state.adaptiveMobilityExternalReducer.backendSolutionFound,
  calculationInProgress: state.adaptiveMobilityExternalReducer.calculationInProgress,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitAMECalCulatorData,
    submitAMEShowData,
    submitAMECalculatorTrackingData,
  }, dispatch),
});

const AdaptiveMobilityExternal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

export default AdaptiveMobilityExternal;
